import { render, staticRenderFns } from "./view-projects-table.vue?vue&type=template&id=6ad9fd62"
import script from "./view-projects-table.vue?vue&type=script&lang=js"
export * from "./view-projects-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports